module.exports = __webpack_public_path__ + "static/media/kids_21.594f23d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_21.jpg
// module id = 5877
// module chunks = 0